export const BILLING_LOADING = '@@reservble/app/billing/BILLING_LOADING';
export const SAVE_BILLING = '@@reservble/app/billing/SAVE_BILLING';
